import {
	DocumentFieldFilter,
	DocumentFilter,
	DocumentLinkTarget,
} from '@dealstack/frontend/shared/dataExchange/services/shared/types';
import { TableOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';

interface Props {
	target: DocumentLinkTarget;
	dataOperations?: TableOperations<DocumentFieldFilter>;
}

export function buildDocumentsQueryKey({ target, dataOperations }: Props): DocumentFilter {
	return {
		...target,
		pagination: dataOperations?.pagination,
		// single sort for now
		sortBy: dataOperations?.sortBy?.[0],
		searchQuery: dataOperations?.search,
		fieldFilter: dataOperations?.filter as DocumentFieldFilter,
	};
}
